import { ThreeDStockContentSearchInImageView } from '../../../ThreeDStockContentSearchInImage/ThreeDStockContentSearchInImageTypes';

interface ThreeDStockContentSearchInImageViewSwitchProps {
  view: ThreeDStockContentSearchInImageView;
  onChange: (view: ThreeDStockContentSearchInImageView) => void;
  disabled?: boolean;
}

function ThreeDStockContentSearchInImageViewSwitch({
  view,
  onChange,
  disabled
}: ThreeDStockContentSearchInImageViewSwitchProps) {
  return (
    <div
      className="inline-flex items-center gap-1 p-1 border border-gray-300 dark:border-gray-700 shadow-sm bg-white dark:bg-gray-800 rounded-md"
      role="group"
      aria-label="Image search mode"
    >
      <button
        type="button"
        className="px-3 py-1.5 rounded text-sm whitespace-nowrap text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 aria-pressed:bg-gray-100 dark:aria-pressed:bg-gray-700 aria-pressed:text-gray-900 dark:aria-pressed:text-white"
        aria-pressed={view === 'single'}
        onClick={() => onChange('single')}
        disabled={disabled}
      >
        Single object
      </button>
      <button
        type="button"
        className="px-3 py-1.5 rounded text-sm whitespace-nowrap text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-700 aria-pressed:bg-gray-100 dark:aria-pressed:bg-gray-700 aria-pressed:text-gray-900 dark:aria-pressed:text-white"
        aria-pressed={view === 'all'}
        onClick={() => onChange('all')}
        disabled={disabled}
      >
        All objects
      </button>
    </div>
  );
}

export default ThreeDStockContentSearchInImageViewSwitch;
